module.exports = __webpack_public_path__ + "img/v8.80382e93.png";